import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';
import { Event } from '../types/events/event';

const useHook = () => {
  return useQuery(['events'], async () => {
    const response = await service.get<Event[]>(`/events`);
    return response.data;
  });
};

export default useHook;
